import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Notification } from 'src/app/core/models/notification.model';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-notifier',
  templateUrl: './notifier.component.html',
  styleUrls: ['./notifier.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotifierComponent implements OnInit {
  currentNotifications: Notification[] = [];

  constructor(private notificationService: NotificationService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.subscribeToNotifications();
  }

  subscribeToNotifications() {
    this.notificationService.notifications.subscribe((notify) => {
      const currentNotification: Notification = {
        type: notify.type,
        message: notify.message,
        title: notify.title
      };

      this.currentNotifications.push(currentNotification);
      this.cdr.detectChanges();
    });
  }

  dispose(index: number) {
    this.currentNotifications.splice(index, 1);
    this.cdr.detectChanges();
  }

}
